import zh from '@/assets/i18n/language/zh';
import en from '@/assets/i18n/language/en';
import vi from '@/assets/i18n/language/vi';

// 国际化配置文件
const i18n = {
	zh: zh,
	en: en,
	vi: vi,
};

export default i18n;
